import React from 'react';
import { useTranslation } from 'react-i18next';
import './VariableChips.css';

interface ChipDef {
    labelKey: string;
    token: string;
}

const CHIPS: ChipDef[] = [
    { labelKey: 'settings.notification.vars.firstName', token: '{first_name}' },
    { labelKey: 'settings.notification.vars.lastName', token: '{last_name}' },
    { labelKey: 'settings.notification.vars.fullName', token: '{name}' },
    { labelKey: 'settings.notification.vars.email', token: '{email}' },
    { labelKey: 'settings.notification.vars.phone', token: '{phone}' },
    { labelKey: 'settings.notification.vars.service', token: '{service}' },
    { labelKey: 'settings.notification.vars.business', token: '{business}' },
    { labelKey: 'settings.notification.vars.date', token: '{date}' },
    { labelKey: 'settings.notification.vars.time', token: '{time}' },
];

interface VariableChipsProps {
    /**
     * Called when the user clicks a chip.
     * The caller is responsible for inserting `token` at the cursor position
     * (or appending it) and updating controlled state.
     */
    onInsert: (token: string) => void;
}

/**
 * A compact row of variable-insert chips rendered above an email textarea.
 * Clicking a chip calls `onInsert` with the corresponding template token so
 * the parent can splice it at the cursor and keep controlled state in sync.
 */
const VariableChips: React.FC<VariableChipsProps> = ({ onInsert }) => {
    const { t } = useTranslation();

    return (
        <div className="variable-chips">
            <span className="variable-chips__label">{t('settings.notification.insertVar')}</span>
            <div className="variable-chips__row">
                {CHIPS.map(({ labelKey, token }) => (
                    <button
                        key={token}
                        type="button"
                        className="variable-chips__chip"
                        title={token}
                        onClick={() => onInsert(token)}
                    >
                        {t(labelKey)}
                    </button>
                ))}
            </div>
            <p className="variable-chips__hint">
                {t('settings.notification.variableHint')}
            </p>
        </div>
    );
};

export default VariableChips;
